/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class Equipment {
    constructor(data) {
        if (data) {
            Object.assign(this, data);
        } else {
            this.fields = [];
            this.inServiceDate = new Date();
            this.location = {};
        }
        this.fieldsByCategory = {};
        this.fields.forEach(field => {
            if (!angular.isArray(this.fieldsByCategory[field.category])) {
                this.fieldsByCategory[field.category] = [];
            }
            this.fieldsByCategory[field.category].push(field);
        });
    }
}

export { Equipment };



// WEBPACK FOOTER //
// ./src/main/front/scripts/model/Equipment.js